var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
import Alert from 'reactstrap/lib/Alert';
import Button from '../components/Button';
var Toast = /** @class */ (function (_super) {
    __extends(Toast, _super);
    function Toast() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            open: true
        };
        _this.closed = false;
        _this.handleClose = function () {
            _this.closed = true;
            _this.setState({ open: false });
            _this.props.onClose && _this.props.onClose();
        };
        return _this;
    }
    Toast.prototype.componentDidMount = function () {
        var _this = this;
        setTimeout(function () {
            if (!_this.closed) {
                _this.handleClose();
            }
        }, 10 * 1000);
    };
    Toast.prototype.render = function () {
        var _this = this;
        return (React.createElement(Alert, { color: this.props.variant, onMouseOver: function () {
                setTimeout(function () {
                    if (!_this.closed) {
                        _this.handleClose();
                    }
                }, 3 * 1000);
            }, onClick: this.handleClose, style: { display: 'flex', justifyContent: 'space-between', verticalAlign: 'middle' } },
            React.createElement("span", { style: { lineHeight: '33px' } }, this.props.message),
            this.props.showRetry &&
                React.createElement("span", null,
                    React.createElement(Button, { color: 'blue', onClick: this.props.onRetry, text: 'Retry' }))));
    };
    return Toast;
}(React.Component));
var ToastComponent = (Toast);
var currentToastId = 0;
export function withToast(WrappedComponent, style) {
    return /** @class */ (function (_super) {
        __extends(class_1, _super);
        function class_1(props) {
            var _this = _super.call(this, props) || this;
            _this.state = {
                toasts: []
            };
            return _this;
        }
        Object.defineProperty(class_1.prototype, "offsets", {
            get: function () {
                var toasts = this.state.toasts;
                return toasts.map(function (item, i) {
                    var index = i;
                    var offset = 20;
                    while (toasts[index - 1]) {
                        offset += (toasts[index - 1].height || 56) + 16;
                        index -= 1;
                    }
                    return offset;
                });
            },
            enumerable: true,
            configurable: true
        });
        class_1.prototype.render = function () {
            var _this = this;
            return (React.createElement(React.Fragment, null,
                React.createElement("div", { style: style }, this.state.toasts.map(function (toast, i) {
                    return React.createElement(ToastComponent, { key: toast.id, message: toast.message, variant: toast.type, onClose: function () {
                            _this.setState({
                                toasts: _this.state.toasts.filter(function (t) { return t.id != toast.id; })
                            });
                        }, onRetry: function () {
                            toast.retryAction && toast.retryAction();
                            _this.setState({
                                toasts: _this.state.toasts.filter(function (t) { return t.id != toast.id; })
                            });
                        }, showRetry: toast.retryAction != undefined });
                })),
                React.createElement(WrappedComponent, __assign({}, this.props, { showToast: function (type, message, retryAction) {
                        _this.setState({
                            toasts: _this.state.toasts.concat([{ type: type, message: message, id: currentToastId++, retryAction: retryAction }])
                        });
                    } }))));
        };
        return class_1;
    }(React.Component));
}
//# sourceMappingURL=Toast.js.map


//////////////////
// WEBPACK FOOTER
// ./bpm-web-generic/lib/HOC/Toast.js
// module id = 289
// module chunks = 0